package one.healthium.settings.ui.menu

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import one.healthium.base.browser.Browser
import one.healthium.base.launcher.LocalPlatformLauncher
import one.healthium.settings.domain.SettingsMenuModel
import one.healthium.settings.ui.components.ArrowIcon
import one.healthium.settings.ui.components.SettingsItem
import one.healthium.ui.compose.components.AppBackNavigationButton
import one.healthium.ui.compose.components.AppLoadingScreen
import one.healthium.ui.compose.components.AppScaffold
import one.healthium.ui.compose.components.AppTopBar
import org.koin.compose.koinInject
import org.koin.compose.viewmodel.koinViewModel
import org.koin.core.annotation.KoinExperimentalAPI

interface SettingsMenuScreenEventDelegate {
    fun onBackClicked()
}

interface SettingsMenuComponent {
    val menuId: String
    val title: String
    fun onBackClicked()
}

@OptIn(KoinExperimentalAPI::class)
@Composable
fun SettingsMenuScreen(component: SettingsMenuComponent) {
    val viewModel = koinViewModel<SettingsMenuViewModel>()
    val state by viewModel.state(component.menuId).collectAsState()

    SettingsMenuScreenContent(
        state = state,
        title = component.title,
        onBackClicked = component::onBackClicked,
    )
}

@OptIn(KoinExperimentalAPI::class)
@Composable
@Deprecated("use component")
fun SettingsMenuScreen(menuId: String, title: String, eventDelegate: SettingsMenuScreenEventDelegate) {
    val viewModel = koinViewModel<SettingsMenuViewModel>()
    val state by viewModel.state(menuId).collectAsState()

    SettingsMenuScreenContent(
        state = state,
        title = title,
        onBackClicked = eventDelegate::onBackClicked,
    )
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
internal fun SettingsMenuScreenContent(
    state: SettingsMenuUiState,
    title: String,
    onBackClicked: () -> Unit,
) {
    AppScaffold(
        topBar = {
            AppTopBar(
                title = {
                    Text(title)
                },
                navigationIcon = { AppBackNavigationButton(onClick = onBackClicked) },
            )
        }
    ) {
        Box(modifier = Modifier.padding(it)) {
            if (state.menu != null) {
                MenuList(
                    menu = state.menu,
                )
            }

            AppLoadingScreen(visible = state.loading)
        }
    }
}

@Composable
fun MenuList(menu: List<SettingsMenuModel>) {
    val browser = koinInject<Browser>()
    val platformLauncher = LocalPlatformLauncher.current

    LazyColumn(
        contentPadding = PaddingValues(top = 24.dp, bottom = 60.dp)
    ) {
        items(menu.size) { index ->
            val settingsMenuModel = menu[index]

            if (index > 0) {
                HorizontalDivider()
            }

            SettingsItem(
                label = settingsMenuModel.title,
                trailing = { ArrowIcon() },
                onClick = {
                    browser.openUrl(platformLauncher, settingsMenuModel.url)
                }
            )
        }
    }
}
